// extracted by mini-css-extract-plugin
export default {"product-list":"FruitDrugList_product-list__qjPkB"};